import { createInjectionKey } from "../../_utils/index.mjs";
export const configProviderInjectionKey = createInjectionKey('n-config-provider');